<template>
  <div class="w_100per">
    <ul class="select-list half">
      <li>
        <a class="select-item" :class="selecttab === 1 ? 'active' : ''" tabindex="0" @click="onClickTab(1)">
          <slot name="firstitem"></slot>
        </a>
      </li>
      <li>
        <a class="select-item" :class="selecttab === 2 ? 'active' : ''" tabindex="0" @click="onClickTab(2)">
          <slot name="seconditem"></slot>
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
import CommonSelectTab from '../../common/CommonSelectTab.vue';

export default {
  extends: CommonSelectTab,
  data() {
    return {};
  },
  methods: {},
  computed: {}
};
</script>
